import { GET_DRIVERS_API } from '../utils/api';

export const LOAD_DRIVER_REQUEST = '@drivers/LOAD_DRIVER_REQUEST';
export const RESET_DRIVER_REQUEST = '@drivers/RESET_DRIVER_REQUEST';
export type DRIVER_REQUEST = typeof LOAD_DRIVER_REQUEST;
export type RESET_REQUEST = typeof RESET_DRIVER_REQUEST;


export interface LoadDriver {
  type: DRIVER_REQUEST;
  payload: {
    drivers: null,
  }
}

export interface zeroDriver {
  type: RESET_REQUEST;
  payload: {
    drivers: null,
  }
}


export async function loadDriver(): Promise<LoadDriver> {
  try {
    const response = await GET_DRIVERS_API();
    return {
      type: LOAD_DRIVER_REQUEST,
      payload: {
        drivers: response.data
      }
    };
  } catch (error) {
    return { 
      type: LOAD_DRIVER_REQUEST, 
      payload: {
        drivers: Object(error)
      }
    }
  }
}

export function resetDriver(): zeroDriver {
  return {
    type: RESET_DRIVER_REQUEST,
    payload: {
      drivers: null
    }
  }
}
